export const houses = [
  { house_nr: 1371, x: 704, y: 179 },
  { house_nr: 1363, x: 670, y: 182 },
  { house_nr: 1362, x: 670, y: 182 },
  { house_nr: 1361, x: 721, y: 184 },
  { house_nr: 1351, x: 759, y: 173 },
  { house_nr: 1345, x: 836, y: 139 },
  { house_nr: 1341, x: 836, y: 139 },
  { house_nr: 1314, x: 810, y: 147 },
  { house_nr: 1313, x: 810, y: 147 },
  { house_nr: 1312, x: 790, y: 149 },
  { house_nr: 1311, x: 790, y: 149 },
  { house_nr: 1212, x: 603, y: 230 },
  { house_nr: 1131, x: 896, y: 158 },
  { house_nr: 1122, x: 851, y: 162 },
  { house_nr: 1121, x: 851, y: 162 },
  { house_nr: 1113, x: 851, y: 162 },
  { house_nr: 1112, x: 687, y: 151 },
  { house_nr: 1111, x: 836, y: 174 },
  { house_nr: 1061, x: 795, y: 204 },
  { house_nr: 1052, x: 790, y: 212 },
  { house_nr: 1051, x: 801, y: 212 },
  { house_nr: 1041, x: 641, y: 188 },
  { house_nr: 1032, x: 665, y: 188 },
  { house_nr: 1031, x: 667, y: 182 },
  { house_nr: 1024, x: 751, y: 204 },
  { house_nr: 1022, x: 751, y: 204 },
  { house_nr: 1021, x: 748, y: 215 },
  { house_nr: 1013, x: 706, y: 150 },
  { house_nr: 1012, x: 706, y: 150 },
  { house_nr: 1011, x: 706, y: 150 },
  { house_nr: 931, x: 606, y: 125 },
  { house_nr: 912, x: 645, y: 132 },
  { house_nr: 911, x: 645, y: 132 },
  { house_nr: 892, x: 441, y: 287 },
  { house_nr: 891, x: 379, y: 317 },
  { house_nr: 852, x: 379, y: 317 },
  { house_nr: 851, x: 379, y: 317 },
  { house_nr: 842, x: 474, y: 267 },
  { house_nr: 841, x: 474, y: 267 },
  { house_nr: 832, x: 465, y: 291 },
  { house_nr: 821, x: 416, y: 306 },
  { house_nr: 812, x: 416, y: 306 },
  { house_nr: 811, x: 416, y: 306 },
  { house_nr: 761, x: 587, y: 184 },
  { house_nr: 752, x: 571, y: 240 },
  { house_nr: 751, x: 571, y: 240 },
  { house_nr: 741, x: 566, y: 211 },
  { house_nr: 731, x: 631, y: 177 },
  { house_nr: 723, x: 579, y: 170 },
  { house_nr: 722, x: 587, y: 184 },
  { house_nr: 721, x: 579, y: 170 },
  { house_nr: 713, x: 587, y: 184 },
  { house_nr: 712, x: 587, y: 184 },
  { house_nr: 711, x: 587, y: 184 },
  { house_nr: 695, x: 538, y: 129 },
  { house_nr: 694, x: 557, y: 121 },
  { house_nr: 693, x: 486, y: 130 },
  { house_nr: 692, x: 522, y: 116 },
  { house_nr: 691, x: 522, y: 116 },
  { house_nr: 643, x: 522, y: 116 },
  { house_nr: 642, x: 100, y: 150 },
  { house_nr: 641, x: 522, y: 116 },
  { house_nr: 622, x: 522, y: 116 },
  { house_nr: 621, x: 522, y: 116 },
  { house_nr: 614, x: 522, y: 116 },
  { house_nr: 613, x: 522, y: 116 },
  { house_nr: 612, x: 522, y: 116 },
  { house_nr: 611, x: 522, y: 116 },
  { house_nr: 551, x: 371, y: 252 },
  { house_nr: 534, x: 341, y: 258 },
  { house_nr: 533, x: 326, y: 272 },
  { house_nr: 532, x: 324, y: 255 },
  { house_nr: 531, x: 324, y: 255 },
  { house_nr: 514, x: 280, y: 291 },
  { house_nr: 513, x: 280, y: 291 },
  { house_nr: 512, x: 280, y: 291 },
  { house_nr: 511, x: 280, y: 291 },
  { house_nr: 494, x: 406, y: 119 },
  { house_nr: 493, x: 406, y: 119 },
  { house_nr: 492, x: 406, y: 119 },
  { house_nr: 491, x: 406, y: 119 },
  { house_nr: 382, x: 179, y: 190 },
  { house_nr: 383, x: 162, y: 189 },
  { house_nr: 381, x: 169, y: 196 },
  { house_nr: 371, x: 204, y: 255 },
  { house_nr: 362, x: 199, y: 136 },
  { house_nr: 361, x: 180, y: 135 },
  { house_nr: 352, x: 196, y: 293 },
  { house_nr: 351, x: 191, y: 275 },
  { house_nr: 341, x: 281, y: 242 },
  { house_nr: 334, x: 260, y: 230 },
  { house_nr: 333, x: 244, y: 237 },
  { house_nr: 332, x: 100, y: 150 },
  { house_nr: 331, x: 239, y: 214 },
  { house_nr: 323, x: 179, y: 207 },
  { house_nr: 322, x: 179, y: 216 },
  { house_nr: 321, x: 192, y: 208 },
  { house_nr: 312, x: 230, y: 176 },
  { house_nr: 311, x: 224, y: 188 },
  { house_nr: 231, x: 114, y: 203 },
  { house_nr: 222, x: 126, y: 214 },
  { house_nr: 221, x: 126, y: 214 },
  { house_nr: 211, x: 93, y: 208 },
  { house_nr: 141, x: 55, y: 170 },
  { house_nr: 131, x: 69, y: 228 },
  { house_nr: 122, x: 55, y: 170 },
  { house_nr: 112, x: 55, y: 170 },
  { house_nr: 111, x: 55, y: 170 },
];
